var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.5C31.9891 22.5 33.8968 23.2902 35.3033 24.6967C36.7098 26.1032 37.5 28.0109 37.5 30C37.5 31.9891 36.7098 33.8968 35.3033 35.3033C33.8968 36.7098 31.9891 37.5 30 37.5C28.0109 37.5 26.1032 36.7098 24.6967 35.3033C23.2902 33.8968 22.5 31.9891 22.5 30C22.5 28.0109 23.2902 26.1032 24.6967 24.6967C26.1032 23.2902 28.0109 22.5 30 22.5ZM30 11.25C42.5 11.25 53.175 19.025 57.5 30C53.175 40.975 42.5 48.75 30 48.75C17.5 48.75 6.825 40.975 2.5 30C6.825 19.025 17.5 11.25 30 11.25ZM7.95 30C9.97064 34.1258 13.1083 37.6019 17.0062 40.0331C20.9041 42.4644 25.406 43.7533 30 43.7533C34.594 43.7533 39.0959 42.4644 42.9938 40.0331C46.8917 37.6019 50.0294 34.1258 52.05 30C50.0294 25.8742 46.8917 22.3981 42.9938 19.9669C39.0959 17.5356 34.594 16.2467 30 16.2467C25.406 16.2467 20.9041 17.5356 17.0062 19.9669C13.1083 22.3981 9.97064 25.8742 7.95 30Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOutlineIcon);
export default __webpack_public_path__ + "static/media/eyeOutlineIcon.486ab92f427e0b55817664344fc926da.svg";
export { ForwardRef as ReactComponent };